import React from 'react';
import ReactDOM from 'react-dom';
import App from './component/App';
import registerServiceWorker, {update} from './registerServiceWorker';
import {Provider} from 'react-redux';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import {configureStore} from './module/Store';
import './index.css';

const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// *** Set up the Service Worker and start polling for updates
registerServiceWorker(() => {
  store.dispatch({
    "type": "NEW_CONTENT_AVAILABLE",
  });
}, () => {
  store.dispatch({
    "type": "CONTENT_CACHED_FOR_OFFLINE",
  });
});
window.setInterval(() => {
  update();
}, 60*1000);



// WEBPACK FOOTER //
// ./src/index.js